import xpost from "../../iframe-bridge/xpost";

interface AnalyticsEvent {
  eventType: string;
  data?: any;
}

export const analyticsEventIPC = xpost(
  "analyticsEvent",
  (input: AnalyticsEvent) => input
);

// Define a reference for the method generated by the analyticsEventIPC
// in order to lazy-initialize it on the first reported event.
let sendAnalyticsEvent: ((event: AnalyticsEvent) => Promise<void>) | null =
  null;

export const logFrameAnalyticsEvent = (eventType: string, data?: any) => {
  if (sendAnalyticsEvent === null) {
    sendAnalyticsEvent = analyticsEventIPC.makeMethod(
      () => window,
      () => window.parent
    );
  }

  sendAnalyticsEvent({ eventType, data });
};
